export default __webpack_public_path__ + "static/media/bigger-stronger-better.0ac4260e.png";